export const applicationStatusesData = [
  { title: 'New', historyBodyText: 'has created new application.', value: 1 },
  {
    title: 'In progress',
    historyBodyText: 'has viewed application details.',
    value: 2,
  },
  {
    title: 'Requested additional information',
    historyBodyText:
      'has requested additional information on application for study',
    value: 3,
  },
  {
    title: 'Re-submitted',
    historyBodyText: 'has re-submitted application.',
    value: 4,
  },
  { title: 'Approved', historyBodyText: 'has approved application.', value: 5 },
  { title: 'Declined', historyBodyText: 'has declined application.', value: 6 },
  {
    title: 'Withdrawn',
    historyBodyText: 'has withdrawn application.',
    value: 7,
  },
];

export const APPLICATION_STATUS_CODE = {
  NEW: 1,
  PROGRESS: 2,
  REQUESTED: 3,
  RE_SUBMITED: 4,
  APPROVED: 5,
  DECLINED: 6,
  WITHDRAW: 7,
};
